import React from 'react';
import { Drawer, Form, Button, Message, useToaster } from 'rsuite';
import { useDispatch, useSelector } from 'react-redux';
import { addGrade } from '@/services/grade.service';
import { useTranslation } from 'react-i18next';
interface DrawerViewProps {
  open: boolean;
  onClose: () => void;
}

const DrawerView: React.FC<DrawerViewProps> = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const toaster = useToaster();
  const grades = useSelector(state => state.grade.data);

  const [formValue, setFormValue] = React.useState({
    grade_name: ''
  });

  React.useEffect(() => {
    if (!open) {
      setFormValue({
        grade_name: ''
      });
    }
  }, [open]);

  const isDuplicateGrade = (name: string) => {
    return grades.some(grade => grade.grade_name.toLowerCase() === name.toLowerCase());
  };

  const handleSubmit = async () => {
    const trimmedGradeName = formValue.grade_name.trim();

    if (!trimmedGradeName) return;

    if (isDuplicateGrade(trimmedGradeName)) {
      toaster.push(
        <Message type="error" duration={5000} showIcon>
          Grade "{trimmedGradeName}" already exists
        </Message>,
        { placement: 'topCenter' }
      );
      return;
    }

    try {
      await dispatch(
        addGrade({
          grade_name: trimmedGradeName
        })
      );
      toaster.push(
        <Message type="success" duration={3000} showIcon>
          {t('Grade successfully created')}
        </Message>,
        { placement: 'topCenter' }
      );
      onClose();
    } catch (error) {
      toaster.push(
        <Message type="error" duration={5000} showIcon>
         {t(' Failed to create grade. Please try again.')}
        </Message>,
        { placement: 'topCenter' }
      );
    }
  };
  const { t } = useTranslation();

  return (
    <Drawer backdrop="static" size="sm" placement="right" onClose={onClose} open={open}>
      <Drawer.Header>
        <Drawer.Title>{t('Create New Grade')}</Drawer.Title>
        <Drawer.Actions>
          <Button
            onClick={handleSubmit}
            appearance="primary"
            disabled={!formValue.grade_name.trim()}
          >
            {t('Save')}
          </Button>
          <Button onClick={onClose} appearance="subtle">
            {t('Cancel')}
          </Button>
        </Drawer.Actions>
      </Drawer.Header>

      <Drawer.Body>
        <Form fluid formValue={formValue} onChange={setFormValue}>
          <Form.Group>
            <Form.ControlLabel>{t('Grade Name')}</Form.ControlLabel>
            <Form.Control name="grade_name" placeholder={t("Enter grade name")} required />
          </Form.Group>
        </Form>
      </Drawer.Body>
    </Drawer>
  );
};

export default DrawerView;
